<template>
  <div v-if="progress" class="gift-progress" :class="`gift-progress--${progress.theme}`" aria-label="本人豪礼资格进度">
    <div v-for="row in progress.rows" :key="row.title" class="gift-progress-row">
      <div class="gift-progress-label"><span>{{ row.title }}</span><span class="gift-progress-amount">已核验 <b>{{ row.current }}</b> / {{ row.required }} 元</span></div>
      <div class="gift-progress-track" role="progressbar" :aria-label="`${row.title}金额进度`" :aria-valuenow="row.percent" aria-valuemin="0" aria-valuemax="100" :aria-valuetext="`已核验${row.current}元，目标${row.required}元`">
        <img v-if="progress.bar" class="gift-progress-art" :src="progress.bar" alt="" />
        <div class="gift-progress-fill" :style="{ width: `${row.percent}%` }"></div>
        <img v-if="progress.icon" class="gift-progress-icon" :src="progress.icon" alt="" :style="{ left: `${row.percent}%` }" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { giftProgressView } from '../../services/activities/giftProgress.mjs';
import { activityUrl } from '../../services/activityPresentation.js';
const props = defineProps({ prize: { type: Object, required: true } });
const progress = computed(() => giftProgressView(props.prize, activityUrl));
</script>

<style scoped>
.gift-progress { --progress-color: var(--kg-primary, #1686cf); margin: 14px 0 16px; }
.gift-progress--world-cup { --progress-color: #16815d; }
.gift-progress-row + .gift-progress-row { margin-top: 14px; }
.gift-progress-label { display: flex; flex-wrap: wrap; justify-content: space-between; gap: 4px 12px; font-size: 12px; line-height: 1.6; color: var(--kg-text-secondary, #64748b); }
.gift-progress-amount { font-variant-numeric: tabular-nums; }
.gift-progress-amount b { color: var(--kg-text, #303747); font-weight: 600; }
.gift-progress-track { position: relative; height: 8px; margin-top: 8px; border-radius: 4px; background: #e5edf4; }
.gift-progress-fill { position: relative; height: 100%; max-width: 100%; border-radius: inherit; background: var(--progress-color); }
.gift-progress--world-cup .gift-progress-track { background: #e0eee8; }
.gift-progress--custom .gift-progress-track { height: 16px; background: #edf2f6; }
.gift-progress-art { position: absolute; width: 100%; height: 100%; object-fit: cover; border-radius: inherit; }
.gift-progress--custom .gift-progress-fill { opacity: .55; }
.gift-progress-icon { position: absolute; top: 50%; width: 24px; height: 24px; margin-left: -12px; transform: translateY(-50%); object-fit: contain; }
.gift-progress--custom { padding-inline: 12px; }
</style>
